import type { SanityMerchCardDocument, SanityPageBuilderSection, SanityPageBuilderShopGridSection } from "@ouster/shared";
import { ShopGridBlockView } from "~/features/blocks/inventory/shop-grid";
import { ShopCard, type ShopCardProps } from "~/features/blocks/inventory/shop-grid/shop-card";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderShopGridSection;
  };
};
type ShopGridViewCard = ShopCardProps & {
  _id?: SanityMerchCardDocument["_id"];
};
function formatPrice(price?: number) {
  return typeof price === "number" ? `$${price.toFixed(2)}` : undefined;
}
export function SanityShopGridSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.products?.map<ShopGridViewCard>(product => ({
    _id: product._id,
    title: product.title,
    price: formatPrice(product.price),
    sizes: product.sizeOptions,
    soldOut: product.soldOut,
    media: hasRenderableSanityMedia(product.image) ? <SanityMediaFigure media={product.image} ratio="496/540" sizes="lg:33vw" /> : undefined,
    // Product detail page path; matches the merchProduct slug (e.g. /merch/cap).
    url: product.slug ? `/merch/${product.slug}` : undefined
  })) ?? [];
  return <ShopGridBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} getItemKey={(card, index) => card._id || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} renderCard={card => <ShopCard {...card} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}